'use client'

import { CurrentCartContext, useRequiredCartContext } from '@/providers/CurrentCartProvider'

export function useCurrentCart() {
  return useRequiredCartContext(CurrentCartContext, 'useCurrentCart')
}
